<template>
  <div class="chats-inner">
    <!--  todo: メッセージタイプ定義 -->
    <div class="chat-left" v-if="directMessage.type === 1 && directMessage.fromParticipantId === targetUser.id">
      <div class="face-icon">
        <img :class="{isAdmin: targetUser.isAdmin()}" :src="targetUser.avatar" />
      </div>
      <div class="chatting wrapper">
        <p>
          <RawHtml :text="directMessage.message" />
        </p>
      </div>
    </div>

    <div class="chat-right" v-if="directMessage.type === 1 && directMessage.fromParticipantId !== targetUser.id">
      <p class="wrapper soft">
        <RawHtml :text="directMessage.message" />
      </p>
    </div>

    <div class="invitedMessage" v-if="directMessage.type === 2">
      <div class="invitedMessage-inner inner">
        <div class="message">
          <span v-if="directMessage.fromParticipantId === targetUser.id">{{ targetUser.name }}さんからトークルームへのお誘いが届きました。</span>
          <span v-else>{{ targetUser.name }}さんへトークルームの招待を送信しました。</span>
        </div>
        <div class="joinRoom-link">
          <router-link :to="{name: 'TalkRoomEntry', params: {roomName: directMessage.message}}" @click.native="invertModalStatus" class="btn">
            <span>ルームに入室する</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RawHtml from "./RawHtml"

export default {
  name: "Message",
  components: {RawHtml},
  props: {
    directMessage: {
      type: Object,
      required: true
    },
    targetUser: {
      type: Object,
      required: true
    }
  },
  methods: {
    invertModalStatus() {
      this.$emit("invert-modal-status")
    }
  }
}
</script>
